import type { ExternalTableSchema } from '@packages/table-builder';

export const jobManagementConsoleTable: ExternalTableSchema = {
  metadata: {
    title: 'Job Management Console',
    entity: 'JobManagementConsole',
  },

  dataSource: {
    endpoint: '/api/taskmanager/api/app/task-manager-console/task-manager-console-list',
    method: 'GET',
    rowIdField: 'taskId',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      Sorting: 'table.sorting',
      SkipCount: 'table.pageOffset',
      MaxResultCount: 'table.pageSize',
      FromCreatedDate: 'filters.createdFromDate',
      ToCreatedDate: 'filters.createdToDate',
      TaskTypeId: 'filters.taskTypeId',
      StatusId: 'filters.reportStatusId',
      CreatedById: 'createdById',
    },
    filters: [
      {
        name: 'taskTypeId',
        placeholder: 'Task Type',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/taskmanager/api/app/task-type/task-type-list',
          labelField: 'taskTypeDisplayName',
          valueField: 'taskTypeId',
        },
      },
      {
        name: 'reportStatusId',
        placeholder: 'Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/taskmanager/api/app/task-status/task-status-list',
          labelField: 'taskStatusDisplayName',
          valueField: 'taskStatusId',
        },
      },
      {
        name: 'createdFromDate',
        placeholder: 'Created Date',
        type: 'date',
      },
      {
        name: 'createdToDate',
        placeholder: 'End Date',
        type: 'date',
      },
    ],
  },

  columns: [
    { field: 'taskReferenceNumber', header: 'Task ID', sortable: true, width: 100 },
    { field: 'taskName', header: 'Task Name', sortable: true, width: 200 },
    { field: 'taskTypeDisplayName', header: 'Task Type', sortable: true, width: 100 },
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'dateTimeLTS',
      sortable: true,
      width: 150,
      visibility: 'picker',
    },
    {
      field: 'completedDate',
      header: 'Completed Date',
      type: 'dateTimeLTS',
      sortable: true,
      width: 150,
    },
    { field: 'createdBy', header: 'Created By', sortable: true, width: 150 },
    {
      field: 'statusDisplayName',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 150,
      align: 'center',
      badge: {
        statusMap: {
          Succeeded: 'success',
          Suceeded: 'success',
          Failed: 'error',
          Cancelled: 'error',
        },
        defaultVariant: 'info',
      },
    },
  ],

  actions: {
    toolbar: {
      primary: { id: 'NAVIGATE_JOB_SCHEDULER', label: 'View Scheduled Task', icon: 'arrow_forward' },
    },
    row: [{ id: 'VIEW_JOB_MANAGEMENT_CONSOLE', label: 'View' }],
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Job Management Console', resizable: true, reorderable: true },
  },
};
